import { useEffect, useState } from "react";
import axios from "axios";

const useUserLocation = () => {
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLocation = async () => {
      if (!navigator.geolocation) {
        setError("Geolocation is not supported by this browser.");
        setLoading(false);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setCoordinates({ lat: latitude, lng: longitude });

          try {
            const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
            );

            const fullAddress =
              response.data.results[0]?.formatted_address || "Address not found";
            setAddress(fullAddress);
          } catch (err) {
            setError("Failed to fetch address");
            console.error(err);
          } finally {
            setLoading(false);
          }
        },
        (err) => {
          setError("Failed to get location");
          console.error(err);
          setLoading(false);
        }
      );
    };

    fetchLocation();
  }, []);

  return { coordinates, address, loading, error };
};

export default useUserLocation;


// https://maps.googleapis.com/maps/api/geocode/json?latlng=28.649470035418123,77.36907424292188&key=AIzaSyDnMvpZ_46Nahhd0_pRWAwJ3O5hbxOsg54